import jsCookie from 'js-cookie';
import { DomainStoryblok } from 'storyblok-types';
import { SHOP_LOCALES } from 'commerce/scayle/constants';
import { getSiteConfigStory } from 'commerce/storyblok/api';
import { getCountryCode } from './api';
import { geoCookieName } from './constants';
import { GetGeoLocationBody } from './types';

export const getGeoLocation = (domainCountry: string) =>
  getGeoLocationBody({
    domainCountry,
    getCountryCode,
    getSiteConfigStory,
    jsCookie,
  });

export const getGeoLocationBody: GetGeoLocationBody = async ({
  domainCountry,
  getCountryCode,
  getSiteConfigStory,
  jsCookie,
}) => {
  const geoWasShown = Boolean(jsCookie.get(geoCookieName));

  if (!geoWasShown && domainCountry) {
    const { response } = await getCountryCode();
    const clientCountryCode = response?.data.countryCode;

    if (
      (domainCountry === SHOP_LOCALES.DE &&
        clientCountryCode === SHOP_LOCALES.AT) ||
      (domainCountry === SHOP_LOCALES.AT &&
        clientCountryCode === SHOP_LOCALES.DE)
    ) {
      const siteConfig = await getSiteConfigStory(domainCountry);

      if (siteConfig) {
        const domains = siteConfig.response?.data.story.content
          .domains as DomainStoryblok[];
        const domainUrl = domains?.find(
          ({ locale }) => locale?.toUpperCase() === clientCountryCode,
        )?.url;

        if (clientCountryCode && domainUrl) {
          return {
            clientCountryCode,
            domainUrl,
          };
        }
      }
    }
  }
};
